export enum ResultCode {
    SUCCESS = 0,
    FAILED = 1,
    CAPTCHA = 10
}
